import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsHikeNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.25 4.306A3.917 3.917 0 0113.17 3h1.49a1.25 1.25 0 011.2.9l1.066 3.667a9.416 9.416 0 006.314 6.383l5.031 1.523A5.25 5.25 0 0132 20.498v.58c0 .43-.05.955-.274 1.48-.33.777-1.083 2.147-2.62 3.324C27.553 27.072 25.282 28 22.034 28h-3.352c-.085 0-.17-.009-.252-.026l-4.779-.982-.88.723a1.25 1.25 0 01-.794.285H5.25A5.25 5.25 0 010 22.75v-.064c0-1.033.408-2.024 1.135-2.757l.258-.26L2.44 9.513A3.917 3.917 0 016.337 6h2.4zM13.17 5.5c-.403 0-.787.172-1.056.473L9.854 8.5H6.338c-.726 0-1.334.549-1.409 1.271L4.027 18.5c3.162.003 4.748.54 6.026 1.107l.427.194c.91.416 1.53.699 2.853.699h10c.504 0 .78-.152 1.008-.366.29-.27.524-.66.867-1.256l.033-.06c.23-.4.522-.91.912-1.374l-3.638-1.101a11.92 11.92 0 01-1.497-.566L18.405 18.4l-1.77-1.765 2.167-2.176a11.967 11.967 0 01-.834-.689l-2.097 2.105-1.77-1.764 2.198-2.207a11.901 11.901 0 01-.582-.89l-2.353 2.363-1.772-1.764 3.027-3.039a12.243 12.243 0 01-.094-.309L13.721 5.5zM3.48 21.115l-.569.574c-.262.265-.41.623-.41.997v.064a2.75 2.75 0 002.75 2.75h6.28l1.455-1.198L18.81 25.5h3.225c2.74 0 4.466-.772 5.552-1.603 1.101-.844 1.626-1.815 1.84-2.318.042-.1.074-.254.074-.502v-.58c0-.736-.293-1.42-.783-1.921a1.25 1.25 0 00-.475.29c-.29.27-.523.66-.866 1.256l-.034.06c-.3.522-.703 1.225-1.292 1.777-.673.63-1.553 1.041-2.717 1.041h-10c-1.884 0-2.943-.488-3.91-.932-.129-.06-.257-.119-.385-.176C8.067 21.462 6.82 21 4 21h-.42c-.031.04-.065.079-.101.115z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHikeNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsHikeNormalMedium;
